// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1924":"5763a7d8","4366":"9b524a2e"}[chunkId] + ".chunk.css";
};